import {useTranslation} from 'react-i18next'
import {ChevronRightIcon} from '@chakra-ui/icons'
import {useBreakpointValue} from '@chakra-ui/react'
import StatusCell from './StatusCell'
import PayeeCell from './PayeeCell'
import DateCell from './DateCell'
import PaymentMethodCell from './PaymentMethodCell'

const calculateFeeAmount = (rowData) =>
  rowData.grossPaymentAmount.subtract(rowData.netPaymentAmount)

const useColumns = () => {
  const {t} = useTranslation('pointsOnPayments')

  const columns = [
    {
      id: 'createdAt',
      header: t(
        'pointsOnPayments:pointsOnPayment.table.columns.headers.createdAt',
      ),
      accessorKey: 'createdAt',
      cell: DateCell,
      enableSorting: true,
    },
    {
      id: 'payeeName',
      header: t(
        'pointsOnPayments:pointsOnPayment.table.columns.headers.payeeName',
      ),
      accessorKey: 'payee.name',
      cell: PayeeCell,
      enableSorting: true,
    },
    {
      id: 'status',
      header: t(
        'pointsOnPayments:pointsOnPayment.table.columns.headers.status',
      ),
      accessorKey: 'status',
      enableSorting: true,
      cell: StatusCell,
    },
    {
      id: 'paymentMethod',
      accessorKey: 'paymentMethod',
      header: t(
        'pointsOnPayments:pointsOnPayment.table.columns.headers.paymentMethod',
      ),
      accessorFn: (rowData) =>
        rowData.paymentMethod?.debitAgreement?.bankName || '',
      cell: PaymentMethodCell,
      enableSorting: true,
      hidden: useBreakpointValue({base: true, '2xl': false}),
    },
    {
      id: 'netPaymentAmount',
      accessorKey: 'netPaymentAmount',
      header: t(
        'pointsOnPayments:pointsOnPayment.table.columns.headers.netPaymentAmount',
      ),
      accessorFn: (rowData) => rowData.netPaymentAmount.getAmount(),
      cell: ({row}) => row.original.netPaymentAmount.toFormat(),
      enableSorting: true,
      hidden: useBreakpointValue({base: true, '1xl': false}),
    },
    {
      id: 'feeAmount',
      accessorKey: 'feeAmount',
      header: t(
        'pointsOnPayments:pointsOnPayment.table.columns.headers.feeAmount',
      ),
      accessorFn: (rowData) => calculateFeeAmount(rowData).getAmount(),
      cell: ({row}) => calculateFeeAmount(row.original).toFormat(),
      enableSorting: true,
      hidden: useBreakpointValue({base: true, '2xl': false}),
    },
    {
      id: 'grossPaymentAmount',
      accessorKey: 'grossPaymentAmount',
      header: t(
        'pointsOnPayments:pointsOnPayment.table.columns.headers.grossPaymentAmount',
      ),
      accessorFn: (rowData) => rowData.grossPaymentAmount.getAmount(),
      cell: ({row}) => row.original.grossPaymentAmount.toFormat(),
      enableSorting: true,
    },
    {
      id: 'chevronRight',
      header: '',
      cell: () => <ChevronRightIcon boxSize="20px" />,
      meta: {
        style: {
          width: '100px',
        },
      },
    },
  ]

  return {columns}
}

export default useColumns
